import { form, errors } from '../state'
import { responseHandlerService } from '@/plugins/responseHandlerService'

/**
 * Form verilerini doğrular
 * @param {Object} contentProps - İçerik özelliklerini içeren nesne
 * @returns {Boolean} Doğrulama sonucu
 */
export const validateForm = (contentProps) => {
  // Hata durumlarını sıfırla
  Object.keys(errors).forEach(key => errors[key] = '')
  
  let isValid = true

  // ContentId kontrolü
  if (contentProps.contentId === undefined || contentProps.contentId === null) {
    errors.contentId = 'İçerik ID zorunludur'
    isValid = false
    responseHandlerService.handleError(null, 'Öneri göndermek için geçerli bir içerik ID gereklidir')
  }

  // Öneri detayı kontrolü
  if (!form.suggestion.trim()) {
    errors.suggestion = 'Öneri detayı boş bırakılamaz'
    isValid = false
  }

  return isValid
}
